export { default } from './TideReadingsTable';
